import { create } from "zustand";
import {
  getAllCouriers,
  getAllData,
  getSystemStatusCode,
  postAssignOrder,
  updateSystemStatusCodeEntries,
} from "../api_layer/api";
import { message } from "antd";

const useSystemStatusStore = create((set) => ({
  couriers: [],
  systemStatusCodes: [],
  statusMappings: [],
  unmappedKeys: [],
  loading: false,
  error: null,

  fetchCouriers: async (tenantId) => {
    set({ loading: true, error: null });
    try {
      const response = await getAllCouriers(tenantId);
      set({ couriers: response.data || [] });
    } catch (error) {
      set({ error: "Failed to fetch couriers" });
      console.error(error);
    } finally {
      set({ loading: false });
    }
  },

  fetchSystemStatusCodes: async (tenantId) => {
    set({ loading: true, error: null });
    try {
      const response = await getSystemStatusCode(tenantId);
      set({ systemStatusCodes: response.data || [] });
    } catch (error) {
      set({ error: "Failed to fetch system status codes" });
      console.error(error);
    } finally {
      set({ loading: false });
    }
  },

  fetchMappings: async ({ tenantId, courier, isMapped }) => {
    set({ loading: true, error: null });
    try {
      const response = await getAllData({ tenantId, courier, isMapped });
      if (isMapped) {
        set({ statusMappings: response.data || [] });
      } else {
        set({ unmappedKeys: response.data || [] });
      }
    } catch (error) {
      set({ error: "Failed to fetch mappings" });
      console.error(error);
    } finally {
      set({ loading: false });
    }
  },

  postMapping: async (payload) => {
    set({ loading: true, error: null });
    try {
      await postAssignOrder(payload);
      set({ loading: false });
      return true;
    } catch (error) {
      set({ error: "Failed to update mapping" });
      console.error(error);
      return false;
    } finally {
      set({ loading: false });
    }
  },

  updatePollers: async (payload) => {
    set({ loading: true, error: null });
    try {
      const response = await updateSystemStatusCodeEntries(payload);
      set({ loading: false });
      message.success("Polling updated successfully!");
      return response;
    } catch (error) {
      set({ error: "Failed to update pollers" });
      console.error(error);
      message.error("Failed to update polling.");
      return null;
    } finally {
      set({ loading: false });
    }
  },
}));

export default useSystemStatusStore;
